
import classNames from 'classnames';
import { Fragment, memo } from 'react';
import './style.scss';
export default memo(() => {
    return (
        <div>
            <div className=' relative post1 rect-[100%_408px]' />
            <div className=' relative post2 rect-[100%_404px]' >
                <div className='absolute rect-[275px_50px] left-[50px] top-[45px]'
                    onClick={() => window.open('https://btt906.com/')} />
                <div className='absolute rect-[275px_50px] left-[50px] top-[119px]'
                    onClick={() => window.open('https://jczy6.com/')}
                />
                <div className='absolute rect-[275px_50px] left-[50px] top-[190px]'
                    onClick={() => window.open('https://zmwjp.com/')}
                />
                <div className='absolute rect-[246px_17px] left-[65px] top-[307px]'
                    onClick={() => window.open('https://t.me/onezyz6')}
                />
            </div>
        </div>
    );
})

